<template>
  <transition name="appfade">
    <div v-show="appIsLoaded" class="intro-page--template page-template">
      <div class="intro-bg">
        <div class="db relative center w-100 vh-100">
          <div class="db absolute left-0 right-0 center tc abs-vert-center">
            <router-link class="bb pointer" to="/home/"></router-link>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { bus } from '../assets/js/src/main';
import Marked from 'marked';
export default {
  //template: '#home-page-template',
  components: {
    //
  },
  props: ['id','pageMarkdownFileName', 'isTicketsPage'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk}` : '';
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      appIsLoaded: true,
      //index = '',
      //
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('index.md');
      return pageData[0];
    },
    player () {
      return this.$refs.youtube.player
    }
  },
  methods: {
    openVidModal(data) {
      console.log('1 ');
      bus.$emit('openVidModal', data);
      console.log('2 ');
    },
    isIntroPageMethod(data) {
      bus.$emit('isIntroPageBus', data);
    }
  },
  mounted() {
    this.$nextTick(() => {
      /****************************
        DOC READY
      ****************************/
      $(function() {

        var $bodyElement = $("#body-element");
        $bodyElement.velocity({ opacity: "1" }, { duration: 1000 }, { easing: "ease-in-out" });


      })
    })
  }
}
</script>